<ng-container *ngIf="showFloatingActionButton$ | async">
	<stages-floating-action-menu
		*ngIf="prompts.length > 0"
		[buttonTitle]="'ai.widget.title'"
		[darkTheme]="true"
		[iconSize]="'24px'"
		[iconClass]="'ico ico-et-aitemplate'"
		[customButtonClasses]="['ai-feature']"
		[menuItems]="menuItems"
		[triggerCloseHandler]="isLoading"
		[isButtonDisabled]="isLoading || menuItems.length === 0"
		[isLoading]="isLoading"
	></stages-floating-action-menu>
</ng-container>
